import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Card from '../../../components/Card/Card';
import Icon from '../../../components/Icon/Icon';
import ICONS from '../../../components/Icon/IconPaths';

class GiftSubscriptions extends Component {
  render() {
    return (
        <div>
          <Link to="/settings" className="mb-4 d-flex align-items-center">
            <Icon icon={ICONS.ARROW_LEFT} size="12" className="Icon --Green-base" />
            <p className="caption --Green-base ml-2 my-0">Back</p></Link>
          <h1 className="mt-0 mb-4">Abbonamenti regalo</h1>
          <Card className="Gift --Annual --Shadow my-4 my-sm-5">
            <div className="header p-4 py-4 px-sm-5 d-flex justify-content-between align-items-center">
              <Icon icon={ICONS.LOGO} size="32" viewbox="64" className="Icon --White" />
              <p className="caption">One Year</p>
            </div>
            <div className="content p-4 p-sm-5">
              <h5 className="m-0">Kenneth Walter-Black</h5>
              <p>You need to check out Good Morning Italia</p>
            </div>
            <div className="footer Border--Top p-4 py-4 px-sm-5 d-block d-sm-flex justify-content-between align-items-center">
              <div className="tag --Disabled-light mb-3 mb-sm-0"><p className="caption">Not activated yet</p></div>
              <button className="btn --Standard --Green-base">Share</button>
            </div>
          </Card>
          <Card className="Gift --Lifetime --Shadow my-4 my-sm-5">
            <div className="header p-4 py-4 px-sm-5 d-flex justify-content-between align-items-center">
              <Icon icon={ICONS.LOGO} size="32" viewbox="64" className="Icon --White" />
              <p className="caption">Lifetime</p>
            </div>
            <div className="content p-4 p-sm-5">
              <h5 className="m-0">Susan Johnson</h5>
              <p>Happy Birthday, I hope you have a great day!</p>
            </div>
            <div className="footer Border--Top p-4 py-4 px-sm-5 d-block d-sm-flex justify-content-between align-items-center">
              <div className="tag --Green-light mr-3"><p className="caption">Activated</p></div>
            </div>
          </Card>
          <Card className="Gift --Six-month --Shadow my-4 my-sm-5">
            <div className="header p-4 py-4 px-sm-5 d-flex justify-content-between align-items-center">
              <Icon icon={ICONS.LOGO} size="32" viewbox="64" className="Icon --White" />
              <p className="caption">Six Months</p>
            </div>
            <div className="content p-4 p-sm-5">
              <h5 className="m-0">Yusef Mahmood</h5>
            </div>
            <div className="footer Border--Top p-4 py-4 px-sm-5 d-block d-sm-flex justify-content-between align-items-center">
              <div className="tag --Green-light mb-3 mb-sm-0"><p className="caption">Activated</p></div>
              <p className="caption">Expires 10/11/2020</p>
            </div>
          </Card>
          <Card className="Gift --Annual --Shadow --Expired my-4 my-sm-5">
            <div className="header p-4 py-4 px-sm-5 d-flex justify-content-between align-items-center">
              <Icon icon={ICONS.LOGO} size="32" viewbox="64" className="Icon --White" />
              <p className="caption">Annual</p>
            </div>
            <div className="content p-4 p-sm-5">
              <h5 className="m-0">John Richardson</h5>
              <p>I thought you’d appreciate this more than anyone. I hope you enjoy it as much as I do every morning!</p>
            </div>
            <div className="footer Border--Top p-4 py-4 px-sm-5 d-block d-sm-flex justify-content-between align-items-center">
              <div className="tag --Red-light mb-3 mb-sm-0"><p className="caption">Expired</p></div>
              <p className="caption">Expired 07/05/2020</p>
            </div>
          </Card>
        </div>
    );
  }
}

export default GiftSubscriptions;